<template>
  <div v-if="!overlay">
    <div v-show="okRules">
      <div class="search bg-lightBlue" style="z-index: 500">
        <div class="search__caption">
          <div class="search__caption__copy">
            <h1>Unlimited</h1>
            <div class="search__caption__copy__searchbox">
              <v-text-field
                class="ctlg"
                v-on:keyup="keyPress"
                dense
                v-model="searchText"
                placeholder="Cerca in Unlimited"
                @click:append="
                  page = 1
                  research(0, 8)
                "
                rounded
                append-icon="search"></v-text-field>
              <a class="cta blue advanced" title="Ricerca Avanzata" style="font-size: 12pt" @click="showResAdv = !showResAdv" v-if="!showResAdv">
                <span>Ricerca Avanzata</span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="search__advanced" v-show="showResAdv">
        <!-- pannello ricerca avanzata - va mostrato al click della CTA Ricerca Avanzata -->
        <div class="search__advanced__copy">
          <span class="panel-close">
            <span class="material-icons" @click="showResAdv = false">close</span>
          </span>
          <div class="search__advanced__copy__item">
            <div class="advanced__row">
              <label class="advanced__row__title">Data</label>
              <hr class="border-blue" />
            </div>
            <v-flex xs12 sm6 md4 class="advanced__row">
              <label style="margin-top: -25px">Da</label>
              <v-text-field label="Anno" outlined type="number" style v-model="dateFrom" :rules="[rules.min, rules.max]"></v-text-field>
              <label style="margin-top: -25px; margin-left: 10px">A</label>
              <v-text-field label="Anno" outlined type="number" v-model="dateTo" :rules="[rules.max]"></v-text-field>
            </v-flex>
          </div>
          <div class="search__advanced__copy__item">
            <div class="advanced__row">
              <label class="advanced__row__title">Autore</label>
              <hr class="border-blue" />
            </div>
            <v-flex xs12 sm6 md4 class="advanced__row">
              <input type="text" name v-model="author" placeholder="Autore" />
            </v-flex>
          </div>
          <div class="search__advanced__copy__item">
            <div class="advanced__row">
              <label class="advanced__row__title">Volume</label>
              <hr class="border-blue" />
            </div>
            <div class="flex advanced__row xs12 sm6 md4">
              <input class="volume__code" type="text" name placeholder="Codice volume" v-model="volume" />
              <input class="isbn__code" type="text" name placeholder="Codice ISBN" v-model="isbn" />
            </div>
            <div class="search__advanced__copy__actions" v-if="showResAdv">
              <!-- va mostrato quando i campi di ricerca vengono popolati -->
              <a
                href="#"
                class="cta orange"
                title="Cerca"
                @click="
                  page = 1
                  research(0, 8)
                ">
                <span>Cerca</span>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="section">
        <v-container>
          <div class="intro">
            <h2>UNLIMITED</h2>
          </div>
          <div class="filter">
            <v-combobox
              class="ctlg mater"
              v-model="materiaSelected"
              :items="materie"
              light
              item-text="nome_interesse"
              dense
              placeholder="Materia"
              rounded
              offset-y
              @change="setMateria()"
              :menu-props="{ auto: true, maxHeight: '250', minWidth: '350' }"></v-combobox>
            <v-switch class="swtch" dense v-model="fav" style="margin-left: 20px; margin-top: 8px" color="green" :label="`PREFERITI`" @change="toggleFav()"></v-switch>
          </div>
          <div v-if="last">
            <v-container style="margin-top: -50px; background: white" class="hidden-sm-and-down">
              <v-pagination style="justify-content: start" v-if="last.length > 0" v-model="page" :length="totalPages" :total-visible="8" circle></v-pagination>
              <!-- GRID box per gestire la visualizzazione a griglia dei volumi -->
              <div class="grid clearfix" style="margin-top: 30px">
                <div class="grid__item" v-for="item in last" :key="item" @click="detail(item)">
                  <a class="grid__item__caption">
                    <div class="grid__item__caption__image">
                      <div class="grid__item__caption__corner" v-if="item._source.provvedimento.utente.demo">DEMO</div>
                      <v-img v-if="item._source.provvedimento.campiCalcolati.cover_url" height="306" width="217" :src="getImage(item._source)"></v-img>

                      <v-img v-else width="217" height="306" :src="settings.configuration.placeholderIMG"></v-img>
                    </div>
                    <div class="grid__item__caption__text">
                      <h4>{{ item._source.provvedimento.titolo }}</h4>
                      <p>
                        <span v-if="item._source.provvedimento.collana">{{
                          item._source.provvedimento.collana.descrizione ? item._source.provvedimento.collana.descrizione : item._source.provvedimento.collana[0].descr
                        }}</span>
                        <br />
                        <span style="font-weight: bold; display: block" v-if="item._source.autori && item._source.autori[0]"
                          >{{ item._source.autori[0].nome.substring(0, 1) }}. {{ item._source.autori[0].cognome }}</span
                        >
                        <span style="font-weight: bold" v-if="item._source.autori && item._source.autori[1]"
                          >{{ item._source.autori[1].nome.substring(0, 1) }}. {{ item._source.autori[1].cognome }}</span
                        >
                      </p>
                    </div>
                  </a>
                </div>
              </div>

              <!-- in versione smartphone invece del div GRID verrà mostrato il div con il carosello immagini -->
              <!--<div class="carousel">
              <div class="corousel__pagination-bullets"></div>
            </div>-->
            </v-container>

            <v-card elevation="24" max-width="444" class="mx-auto hidden-md-and-up" style="height: 306px; !important; width: 217px; !important">
              <v-carousel v-model="model" hide-delimiters @change="carousel(item)">
                <v-carousel-item v-for="item in last" :key="item" @click="detail(item)">
                  <v-img v-if="item._source.provvedimento.campiCalcolati.cover_url" height="306" width="217" :src="getImage(item._source)"></v-img>

                  <v-img v-else width="217" height="306" :src="settings.configuration.placeholderIMG"></v-img>
                </v-carousel-item>
              </v-carousel>
            </v-card>
            <v-row justify="space-around" v-if="currentItem" style="margin-top: 20px" class="mx-auto hidden-md-and-up">
              <div class="grid__item__caption__text">
                <h4>{{ currentItem._source.provvedimento.titolo }}</h4>
                <p>
                  <span v-if="currentItem._source.provvedimento.collana">{{
                    currentItem._source.provvedimento.collana.descrizione
                      ? currentItem._source.provvedimento.collana.descrizione
                      : currentItem._source.provvedimento.collana[0].descr
                  }}</span>
                  <br />
                  <span style="font-weight: bold" v-if="currentItem.autori && currentItem.autori[0]"
                    >{{ currentItem.autori[0].nome.substring(0, 1) }}. {{ currentItem.autori[0].cognome }}</span
                  >
                  <span style="font-weight: bold" v-if="currentItem.autori && currentItem.autori[1]"
                    >{{ currentItem.autori[1].nome.substring(0, 1) }}. {{ currentItem.autori[1].cognome }}</span
                  >
                </p>
              </div>
            </v-row>
          </div>
          <h1 v-else style="text-align: center; margin: 0 auto">
            <v-progress-circular style="margin-top: 20px" indeterminate color="primary"></v-progress-circular>
          </h1>
          <v-container class="fill-height container--fluid" v-show="last && showNoUnlimited">
            <div class="modal row align-center justify-center">
              <a class="close" @click="showNoUnlimited = false"><span class="mdi mdi-close"></span></a>
              <div class="popup">
                <div class="popup__caption">
                  <div class="popup__caption__row">
                    <h3>Non hai ancora aggiunto nessun titolo a UNLIMITED</h3>
                  </div>
                  <div class="popup__caption__row">
                    <a @click="showNoUnlimited = false" class="cta blue">Comincia subito</a>
                  </div>
                </div>
              </div>
              <div class="popup-filter"></div>
            </div>
          </v-container>
        </v-container>
      </div>
    </div>
    <div v-show="!okRules" style="margin-top: -25px">
      <NoContentView :settings="settings"></NoContentView>
    </div>
  </div>
</template>
<style>
  .ctlg .v-input__slot {
    border: solid 1px #cdcdcd;
    height: 40px !important;
    font-size: 10pt;
  }

  .v-input__icon.v-input__icon--append {
    margin-top: 3px;
  }
  .v-card {
    transition: opacity 0.3s ease-in-out;
  }
  .v-menu__content {
    /*box-shadow: none !important;*/
  }
  .v-card:not(.on-hover) {
    opacity: 0.8;
  }
  .order.v-list.v-sheet.v-sheet--tile.theme--light.v-list--dense {
    margin-top: 40px !important;
    margin-left: 125px !important;
    overflow-y: hidden !important;
  }
  .titl {
    cursor: pointer;
  }
  .titl:hover {
    text-decoration: underline;
  }

  .v-input__slot input::-webkit-outer-spin-button,
  .v-input__slot input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  .v-input__slot input[type='number'] {
    border: none;
  }
  .search__caption__copy__searchbox .cta.orange {
    display: block;
    font-size: 10pt;
  }
  .ctlg {
    width: 50%;
    display: inline-flex;
  }

  i.v-icon.notranslate.mdi.mdi-menu-down.theme--light {
    cursor: pointer !important;
  }

  @media (max-width: 767px) {
    .ctlg {
      width: 100% !important;

      margin-left: 0px !important;
    }
    .mater {
      padding-right: 40px;
    }
  }
  @media (max-width: 767px) {
    .swtch {
      margin-left: 150px !important;
    }
  }
</style>
<script>
  import NoContentViewVue from '../components/unlimited/NoContentView.vue'
  import axios from 'axios'

  export default {
    props: {
      authorization: {
        type: Object
      },
      overlay: {
        type: Boolean
      },
      settings: {
        type: Object
      }
    },
    components: {
      NoContentView: NoContentViewVue
    },
    data: (vm) => ({
      page: 1,
      totalPages: 1,
      loaded: false,
      dateFrom: null,
      dateTo: null,
      author: '',
      user: null,
      catalogue: null,
      materie: [],
      fav: false,
      materiaSelected: null,
      totalResults: 0,
      searchText: null,
      chapterText: '',
      errorMin: false,
      errorMax: false,
      volume: null,
      isbn: null,
      rules: {
        min: (value) => vm.check(value, true),
        max: (value) => vm.check(value, false)
      },
      showNoUnlimited: false,
      list: [],
      last: null,
      showResAdv: false,
      nlp: null,
      currentItem: null,
      currentOrder: {
        id: 1,
        name: 'Più pertinente',
        sort: {
          name: '_score',
          order: 'desc'
        }
      },
      orders: [
        {
          id: 1,
          name: 'Più pertinente',
          sort: {
            name: '_score',
            order: 'desc'
          }
        },
        {
          id: 2,
          name: 'Più recente',
          sort: {
            name: 'provvedimento.data',
            order: 'desc'
          }
        }
      ]
    }),
    watch: {
      page(val) {
        this.research((val - 1) * 8, 8, true, true)
        this.$gtm.trackEvent({
          event: 'sezione',
          azione: 'open',
          descrizione: 'unlimited',
          proprieta: val,
          utente: this.authorization && this.authorization.profile && this.authorization.profile.userId ? this.authorization.profile.userId : null,
          crmid: this.authorization && this.authorization.profile && this.authorization.profile.crmId ? this.authorization.profile.crmId : null,
          stato: ''
        })
      }
    },
    mounted() {
      //this.$gtm.trackView('pageview', this.$route.path)

      this.$emit('checkQSTicket', this.$route.query) //va messo in tutte le viste

      if (this.authorization.jwt) {
        this.user = this.authorization
        this.checkRules()
      }
      if (this.settings.freeToken == false && this.okRules) {
        var header = {
          Authorization: localStorage.token_biblio_vol_jwt
        }

        if (localStorage.materie) {
          //controllo la data di scadenza per il refresh, settata a 20 min
          if (localStorage.dateSavedMaterie) {
            var now = Date.parse(new Date()) / 1000
            var exp = parseInt(localStorage.dateSavedMaterie) + parseInt(this.settings.configuration.timeoutReloadMaterie)
            if (now >= exp) {
              this.loadMaterie(header)
            } else {
              this.materie = JSON.parse(localStorage.materie)
            }
          } else {
            localStorage.materie = []
            this.loadMaterie(header)
          }
        } else {
          this.loadMaterie(header)
        }

        //

        this.recoverUnlimited()
      } else {
      }
    },
    created() {
      this.$gtm.trackEvent({
        event: 'sezione',
        azione: 'open',
        descrizione: 'unlimited',
        proprieta: this.page,
        utente: this.authorization && this.authorization.profile && this.authorization.profile.userId ? this.authorization.profile.userId : null,
        crmid: this.authorization && this.authorization.profile && this.authorization.profile.crmId ? this.authorization.profile.crmId : null,
        stato: ''
      })
    },
    methods: {
      async REQUEST(call, header, method, type, body, first, changingPage) {
        var self = this
        this.loading = true
        if (method == 'POST') {
          await axios
            .post(call, body, { headers: header })
            .then(function (response) {
              switch (type) {
                case 'search':
                  self.last = response.data.es.list
                  self.showResAdv = false
                  self.currentItem = self.last[0]
                  self.totalResults = response.data.es.total
                  self.totalPages = parseInt(Math.round(self.totalResults / 8)) >= 1 ? parseInt(Math.ceil(self.totalResults / 8)) : 1
                  self.loaded = true
                  if (!first) {
                    self.settings.catalogo = {
                      search: response.data,
                      materiaSelected: self.materiaSelected,
                      materie: self.materie,
                      fromDetail: false,
                      filters: {
                        dateFrom: self.dateFrom,
                        dateTo: self.dateTo,
                        author: self.author,
                        typeResearch: 'Unlimited',
                        currentPage: self.page,
                        fromVolumes: false,
                        fromUnlimited: true
                      }
                    }

                    if (changingPage) {
                    } else {
                      self.$router.push({
                        path: 'results',
                        query: { more: true }
                      })
                    }
                  }
                  self.showResAdv = false
                  break
              }
            })
            .catch(function (error) {
              //localStorage.token_biblio_vol = null;
              localStorage.token_biblio_vol_jwt = self.settings.free.jwt
              self.token = self.settings.free.jwt
              //self.settings.freeToken = true;
            })
        } else {
          await axios
            .get(call, { headers: header })
            .then(function (response) {
              switch (type) {
                case 'materie':
                  self.materie = response.data.materie
                  self.materie.unshift({
                    nome_interesse: 'Tutto il catalogo'.toUpperCase()
                  })
                  localStorage.materie = JSON.stringify(self.materie)
                  localStorage.dateSavedMaterie = Date.parse(new Date()) / 1000
                  break
              }
            })
            .catch(function (error) {
              self.loaded = true
            })
        }
      },
      checkRules() {
        var roleUnlimited = this.user.profile.roles.find((x) => x.pos.toString().toLowerCase() == 'bvunlimited')
        if (roleUnlimited) this.okRules = true
        else {
          /*var roleDemo = this.user.profile.roles.find(x => x.pos == 36);
        if (roleDemo) {
          this.okRules = true;
        } else this.okRules = false;*/
          this.okRules = false
        }
      },
      toggleFav() {
        this.page = 1
        this.research((this.page - 1) * 8, 8, true, true)
      },
      check(val, from) {
        //value <= vm.dateTo || 'Errore nelle date'
        if (from) {
          if (parseInt(val) > parseInt(this.dateTo)) {
            return 'Errore nelle date.'
          }
        } else {
          if (val != '' && parseInt(val) < parseInt(this.dateFrom)) return 'Errore nelle date.'
        }
        return true
      },
      loadMaterie(header) {
        this.REQUEST(this.settings.configuration.apiURL + '/materie', header, 'GET', 'materie', null)
      },
      moreResults() {
        this.settings.catalogo = null
        this.$router.push({
          path: 'results',
          query: { more: true }
        })
      },
      carousel(item) {
        this.currentItem = this.last[this.model]
      },
      setMateria() {
        this.page = 1
        this.research((this.page - 1) * 8, 8, true, true)
      },
      setOrder(item) {
        this.currentOrder = item
        this.research((this.page - 1) * 8, 8)
      },
      verifyUserConditions(item, type) {
        if (type == 'unlimited') {
          if (this.settings.freeToken) {
            return false
          } else {
            if (item._source.provvedimento.utente.unlimited == false && item._source.provvedimento.is_unlimited) {
              return true
            } else return false
          }
        } else if (type == 'abbonato') {
          if (this.settings.freeToken) {
            return false
          } else {
            if (item._source.provvedimento.utente.volume) {
              return true
            } else return false
          }
        }
      },
      getImage(item) {
        //BVA-93
        let prefix = this.settings.copertina + '/pdf/'
        let uri = item.provvedimento.idDocMaster.toString().substring(item.provvedimento.idDocMaster.toString().length - 3, item.provvedimento.idDocMaster.toString().length)
        let fix = '/' + item.provvedimento.campiCalcolati.cover_url
        let final = prefix + uri + fix.replace('//', '/') + '?width=217&fit=outside'
        return final.replace(/([^:]\/)\/+/g, '$1')
      },
      detail(item) {
        this.$router.push({
          path: '/details',
          query: { cod_vol: item._source.provvedimento.codVol, from: 'Unlimited' }
        })
      },
      createSessionTimestamp() {
        var d = new Date()
        var session = d.getFullYear().toString() + d.getMonth().toString() + d.getDate().toString() + d.getHours() + d.getMinutes() + d.getSeconds()
        return session
      },
      keyPress(e) {
        if (e.keyCode === 13) {
          this.page = 1
          this.research((this.page - 1) * 8, 8)
        }
      },
      async recoverUnlimited(header) {
        this.last = []
        var header = {
          Authorization: localStorage.token_biblio_vol_jwt
        }
        var body = {
          filters: [
            { name: 'codiciUnlimited', value: true },
            { name: 'codiciPreferiti', value: this.fav }
          ],
          sort: { name: 'provvedimento.data', order: 'desc' }
        }
        await this.REQUEST(this.settings.configuration.apiURL + '/search/volumi/0/8', header, 'POST', 'search', body, true)
        if (this.totalResults == 0) this.showNoUnlimited = true
        else this.showNoUnlimited = false
      },
      research(from, to, fav, changingPage) {
        var body = {}
        var stop = false
        if ((this.searchText != null && this.searchText.length > 0) || this.showResAdv || fav) {
          if (this.materiaSelected && this.materiaSelected.nome_interesse.toUpperCase() != 'TUTTO IL CATALOGO') {
            body = {
              filters: [
                { name: 'materia', value: [this.materiaSelected.interesse_id] },
                { name: 'codiciPreferiti', value: this.fav }
              ]
            }
          } else {
            body = {
              filters: [{ name: 'codiciPreferiti', value: this.fav }]
            }
          }
          if (!changingPage) {
            body.filters.push({
              name: 'volumiUnlimited',
              value: true
            })
          } else {
            body.filters.push({
              name: 'codiciUnlimited',
              value: true
            })
          }
          if (this.searchText) {
            body.text = this.searchText
            body.filters = body.filters.filter((x) => x.name != 'codiciPreferiti')
          }
          if (!this.searchText && this.showResAdv && this.author) {
            body.text = this.author
          }
          if (!this.searchText) {
            //PBV-277
            body.sort = {
              name: 'provvedimento.data',
              order: 'desc'
            }
          } else body.sort = { name: '_score', order: 'desc' }

          var flagAuthor = false
          if (this.showResAdv) {
            var filterDate = {}
            //verifiche
            var dateFrom = this.dateFrom ? this.dateFrom : 1930
            var dateTo = this.dateTo ? this.dateTo : new Date().getFullYear()
            if (parseInt(dateFrom) <= parseInt(dateTo) && parseInt(dateFrom) > 0 && parseInt(dateTo) > 0) {
              if (dateFrom != null || dateTo != null) {
                filterDate.name = 'range'
                var values = {
                  from: dateFrom ? dateFrom.toString() + '-01-01T00:00:00' : '1930-01-01T00:00:00',
                  to: dateTo ? dateTo.toString() + '-12-31T00:00:00' : '2100-01-01T00:00:00'
                }
                filterDate.value = values
                body.filters.push(filterDate)
              }
              var filterAuthor = {}
              if (this.author != '' && this.author != null) {
                filterAuthor.name = 'autore'
                var values = {
                  cognome: this.author
                }
                filterAuthor.value = values
                body.filters.push(filterAuthor)
                flagAuthor = true
              }
              var filterVolume = {}
              if (this.volume != '' && this.volume != null) {
                //gestione errore 9 caratteri
                if (this.volume.length < 9) {
                  alert('Il codice volume deve essere di 9 caratteri')
                }
                filterVolume.name = 'codVol'
                filterVolume.value = this.volume.toString()
                body.filters.push(filterVolume)
              }
              var filterISBN = {}
              if (this.isbn != '' && this.isbn != null) {
                filterISBN.name = 'isbn'
                filterISBN.value = this.isbn.toString()
                body.filters.push(filterISBN)
              }
            } else {
              if (this.dateFrom && this.dateTo) stop = true
            }
          }
          if (!stop) {
            var nlp = ''
            var header = {
              Authorization: localStorage.token_biblio_vol_jwt
            }
            this.REQUEST(this.settings.configuration.apiURL + '/search/volumi/' + from + '/' + to + nlp, header, 'POST', 'search', body, false, changingPage)
          }
        }
      }
    }
  }
</script>
